import styled from '@emotion/styled';
import { MixinVisuallyHidden } from './DefaultStyles';

export const BodyLayout = styled.div<{ $offset?: number }>`
    height: calc(100dvh - ${(props) => (props.$offset ? props.$offset : 0)}px);
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const BodyHeaderWrapper = styled.div`
    flex-shrink: 0; /* Prevent shrinking */
    width: 100%;
`;

export const BodyMainContent = styled.main`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    flex: 1;
    &[data-managed='true'] {
        border-left: 10px solid ${(props) => props.theme.color.indicator};
    }
`;

export const BodyPageContent = styled.div`
    flex: 1;
    display: flex;
    overflow: hidden;
    overflow-y: auto;
    scrollbar-color: ${(props) => props.theme.color.accent} ${(props) => props.theme.color.cardHover};
    scrollbar-width: thin;
`;

export const StickyFooter = styled('div')<{
    $visuallyHide: boolean;
    contentPosition?: 'flex-end' | 'flex-start' | 'center' | 'space-between' | 'space-around';
}>`
    background-color: ${({ theme }) => theme.color.background};
    position: sticky;
    bottom: 0;
    padding: 1rem 0;
    display: flex;
    justify-content: ${({ contentPosition }) => contentPosition || 'flex-end'};

    ${({ $visuallyHide }) => $visuallyHide && MixinVisuallyHidden}
`;

export const StickyFooterStretch = styled(StickyFooter)`
    flex: 1;
    width: 100%;
`;

export const ContentWrapper = styled.div`
    padding: 1rem 1rem 2rem 1rem;
`;

export const DisabledWrapper = styled.div`
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
    position: relative;

    .interaction-blocker {
        position: absolute;
        inset: 0;
        z-index: 1;
        background: transparent;
        cursor: not-allowed;
    }
`;
